import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";
import {
  PDFProgressData,
  PDFDocumentProxy,
  PDFSource as DocumentInitParameters,
} from "ng2-pdf-viewer";
import {
  DataArray,
  AuthorizationService,
  SurveySettings,
  SurveyService,
  SurveyDocument,
  SurveyCompany,
  SurveyMinesite,
  SurveyUser,
  SurveyStatus,
  Language,
  CompanyService,
  MinesiteService,
  Company,
  Minesite,
  UserService,
} from "../../../shared/index";
import { SurveyConflictResolution } from "../../../shared/model/surveyconflictresolution.model";
import { formatDate } from "@angular/common";

enum SurveyManagementView {
  SurveyInformation = "Survey Information",
  UploadPDF = "Upload PDF",
  Assignments = "Assignments",
  SurveyPreview = "Survey Preview",
  SurveyReport = "Survey Report",
}

enum DataEntryMode {
  Add,
  Edit,
  Default,
}

@Component({
  selector: "survey-list",
  templateUrl: "./survey-list.html",
  standalone: false,
})
export class SurveyListComponent implements OnInit, OnDestroy {
  @ViewChild("surveyEditModal") editSurveyModal: ModalDirective;
  @ViewChild("surveyFilterModal") filterSurveysModal: ModalDirective;
  @ViewChild("deleteConfirmation") delConfirmModal: ModalDirective;
  @ViewChild("disableConfirmation") disableConfirmModal: ModalDirective;
  @ViewChild("errModal") errModal: ModalDirective;
  @ViewChild("invalidDate") invalidDate: ModalDirective;
  @ViewChild("surveyConflictModal") surveyConflictModal: ModalDirective;

  public SurveyManagementView = SurveyManagementView;
  public currentView: SurveyManagementView =
    SurveyManagementView.SurveyInformation;

  public surveySettingsList: DataArray<SurveySettings> =
    new DataArray<SurveySettings>(1);
  public surveySettings: SurveySettings = new SurveySettings();
  public surveySettingsUnaltered: SurveySettings = new SurveySettings();
  public surveyDocument: SurveyDocument = new SurveyDocument();
  public surveyUser: SurveyUser = new SurveyUser();
  public currentSurveySettings: SurveySettings = new SurveySettings();
  public surveyConflictResolutions: SurveyConflictResolution[] = [];

  public surveyPkid = [];

  public companies: Company[] = [];
  public minesites: Minesite[] = [];
  public selectedCompanies: number[] = [];
  public selectedMinesites: number;
  public selectedMinesitesForRemoval: number;
  public selectedCompany: number;
  public selectedCompanyForRemoval: number;
  public filteredMinesites: Minesite[];
  public companyfilterApplied = false;
  public surveyEntityList: String[] = ["All Users", "Companies", "Minesites"];
  public surveyCompanys: SurveyCompany[] = [];
  public surveyMinesites: SurveyMinesite[] = [];
  public finalMinesites: Minesite[] = [];
  public finalCompanies: Company[] = [];

  public historyDocuments: SurveyDocument[] = [];
  public surveyStatuses: SurveyStatus[] = [];
  public usersSeen = 0;
  public usersIgnored = 0;
  public usersCompleted = 0;
  public usersIgnoredForever = 0;
  public usersNotified = 0;

  public languages: Language[] = [];

  public selected: number[] = [];
  private subscriptions: Subscription[] = [];

  // Filter pop-up variables
  public filterApplied = false;
  public filterTitle = "";
  public filterProductDescription = "";
  public filterLanguage = "";
  public filterDivision = "";
  public filterCreatedBy = "";

  public orderBy = "CreatedOn";
  public filterIsActive = false;
  public filterAllowIgnore = false;
  public startDate = null;
  public expiresDate = null;
  public ascending = false;
  public totalDocuments = 0;
  public total = 0;
  public currentUser = "";
  public currentUserId = 0;
  public DataEntryMode = DataEntryMode;
  public dataEntryMode: DataEntryMode = DataEntryMode.Default;

  public processingAzurePDF = false;
  public uploadAzurePDFCompleted = false;
  public uploadAzurePDFError = false;
  public errMsgAzurePDF = "";

  public processing = true;
  public downloadingDocument = false;
  public pdfSrc: string | Uint8Array | DocumentInitParameters | null = null;

  public loadingCompanies = false;
  public loadingMinesites = false;
  public loadingCompanyAssignments = false;
  public loadingMinesiteAssignments = false;

  public changesMade = false;

  public printTemplateErrorMsg = "";
  public errModalTitle = "";
  public errModalMsg = "";
  public deleteConfirmationProductName = "";
  public deleteSurveyId = 0;

  public updatedFileName = "";

  //NOTE: This property was referenced in the template as `[class.disabled]="disable"`
  //	However, it was not defined in the component, and switching to strictTemplate: true in tsconfig.json caused an error.
  //	Adding the property here to resolve the error since it resolved to falsy before
  //  Assumption: this may have been intended to be part of the iterated object, but was not implemented.
  public disable = false;

  constructor(
    private _ngZone: NgZone,
    private _authorizationService: AuthorizationService,
    private _surveyService: SurveyService,
    private _companyService: CompanyService,
    private _userService: UserService,
    private _minesiteService: MinesiteService
  ) {
    this.subscriptions.push(
      this._minesiteService.minesitesChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.minesites = info;
          this.filteredMinesites = this.minesites;
          this.loadingMinesites = false;
          this.handleMinesiteAssignment();
        });
      })
    );
    this.subscriptions.push(
      this._companyService.companysChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          //handle pagination
          if (info.companies.length > 0) {
            this.companies = [...this.companies, ...info.companies];
          }

          if (!info.isFinalPage) return;

          this.loadingCompanies = false;

          if (this.surveySettings.SurveyAssignment == 2) {
            this.handleCompanyAssignment();
          } else {
            this.handleMinesiteAssignment();
          }
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.surveySettingsChange.subscribe(
        (surveySettingsList: SurveySettings[]) => {
          this._ngZone.run(() => {
            this.total = this._surveyService.totalSurveys;
            if (this.totalDocuments === 0) {
              this.totalDocuments = this.total;
            }

            this.surveySettingsList.init();
            for (const _survey of surveySettingsList) {
              this.surveySettingsList.update(_survey, true);
            }

            this.processing = false;
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveyDocumentCreated.subscribe(
        (info: SurveyDocument) => {
          this._ngZone.run(() => {
            if (info.Pkid != -1) {
              const filePathInput: any = $("#pdfFileInput");
              this.surveySettings.FileMetadataId = info.Pkid;

              if (filePathInput[0].files.length > 0) {
                const file: any = filePathInput[0].files[0];

                /// Upload the file
                this.processingAzurePDF = true;
                this.uploadAzurePDFError = false;
                this.errMsgAzurePDF = "";

                const formData: FormData = new FormData();
                formData.append(
                  "files",
                  file,
                  this.surveySettings.Pkid.toString() + file.name
                );
                this._surveyService.uploadPDF(formData, true, info.Pkid);
              }

              this.historyDocuments = [];
              this._surveyService.getSurveyDocumentHistory(
                this.surveySettings.FileMetadataId
              );
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveySettingsCreated.subscribe(
        (info: SurveySettings) => {
          this._ngZone.run(() => {
            if (info.Pkid != -1) {
              this.surveySettings = info;
              this.dataEntryMode = DataEntryMode.Edit;
              this.historyDocuments = [];
              this._surveyService.getSurveyDocumentHistory(
                this.surveySettings.FileMetadataId
              );
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.languageChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.languages = info;
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.surveySettingsDeleted.subscribe(
        (info: SurveySettings) => {
          this._ngZone.run(() => {
            if (info.Pkid != -1) {
              this.delConfirmModal.hide();
              this.reloadSurveys();
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveySettingsDeactivated.subscribe(
        (info: SurveySettings) => {
          this._ngZone.run(() => {
            if (info.Pkid != -1) {
              this.disableConfirmModal.hide();
              this.reloadSurveys();
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveySettingsEnabled.subscribe(
        (info: SurveySettings) => {
          this._ngZone.run(() => {
            if (info.Pkid != -1) {
              this.reloadSurveys();
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveySettingsUpdated.subscribe(
        (_survey: SurveySettings) => {
          this._ngZone.run(() => {
            if (_survey.Pkid != -1) {
              this.total = this._surveyService.totalSurveys;
              this.surveySettings = _survey;
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveyDocumentHistoryChange.subscribe(
        (documents: SurveyDocument[]) => {
          this._ngZone.run(() => {
            this.retrievedSurveyDocumentPDFId = 0;
            this.historyDocuments = documents;
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveyCompaniesChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.surveyCompanys = info;
          this.loadingCompanyAssignments = false;
          this.handleCompanyAssignment();
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.surveyMinesitesChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.surveyMinesites = info;
          this.loadingMinesiteAssignments = false;
          this.handleMinesiteAssignment();
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.surveyUsersChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.surveyUser = info;
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.currentSurveySettingsChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.currentSurveySettings = info;
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.getSurveySettingsByIdError.subscribe((info: any) => {
        this._ngZone.run(() => {});
      })
    );

    this.subscriptions.push(
      this._surveyService.warnAboutSurveyConflicts.subscribe((info: any) => {
        this._ngZone.run(() => {
          // TODO: Need to convert to a foreach to grab all conflicts.
          this.surveyConflictResolutions = info;
          this.invalidDate.show();
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.warnAboutSurveyConflictsForEnable.subscribe(
        (info: any) => {
          this._ngZone.run(() => {
            // TODO: Need to convert to a foreach to grab all conflicts.
            this.surveyConflictResolutions = info;
            this.surveyConflictModal.show();
          });
        }
      )
    );

    this.subscriptions.push(
      this._surveyService.surveyStatusesChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.surveyStatuses = info;
          for (const stat of this.surveyStatuses) {
            if (stat.ActionType == "IGNORED") {
              this.usersIgnored = stat.UserCount;
            } else if (stat.ActionType == "VIEWED") {
              this.usersSeen = stat.UserCount;
            } else if (stat.ActionType == "COMPLETED") {
              this.usersCompleted = stat.UserCount;
            } else if (stat.ActionType == "NOTIFIED") {
              this.usersNotified = stat.UserCount;
            } else if (stat.ActionType == "IGNORED_FOREVER") {
              this.usersIgnoredForever = stat.UserCount;
            }
          }
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.pdfAzureChange.subscribe((result: boolean) => {
        this._ngZone.run(() => {
          (document.getElementById("pdfFileInput") as HTMLInputElement).value =
            null;
          this.processingAzurePDF = false;
          this.uploadAzurePDFCompleted = true;
        });
      })
    );

    this.subscriptions.push(
      this._surveyService.pdfAzureError.subscribe((result: string) => {
        this._ngZone.run(() => {
          (document.getElementById("pdfFileInput") as HTMLInputElement).value =
            null;
          this.processingAzurePDF = false;
          this.uploadAzurePDFCompleted = false;

          this.uploadAzurePDFError = true;
          this.errMsgAzurePDF = result;
        });
      })
    );
  }

  ngOnInit(): void {
    this._surveyService.getAllSurveySettings(
      this.filterApplied,
      this.orderBy,
      this.ascending,
      this.filterTitle,
      this.filterLanguage,
      this.filterAllowIgnore,
      this.filterIsActive,
      this.filterCreatedBy,
      this.startDate,
      this.expiresDate
    );
    this._surveyService.getLanguages();

    this.currentUser = this._authorizationService.userName;
    this.currentUserId = this._authorizationService.userId;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  // StartDate with getter and setter, needed for date input
  get SurveyStartDate(): string {
    return this.surveySettings.StartDate
      ? formatDate(this.surveySettings.StartDate, "yyyy-MM-dd", "en-US")
      : "";
  }
  set SurveyStartDate(value: string | Date) {
    this.surveySettings.StartDate =
      typeof value === "string" ? new Date(value) : value;
  }

  // ExpiresDate with getter and setter, needed for date input
  get SurveyExpiresDate(): string {
    return this.surveySettings.ExpiresDate
      ? formatDate(this.surveySettings.ExpiresDate, "yyyy-MM-dd", "en-US")
      : "";
  }
  set SurveyExpiresDate(value: string | Date) {
    this.surveySettings.ExpiresDate =
      typeof value === "string" ? new Date(value) : value;
  }

  public getMinesitesForCompany(): void {
    this.companyfilterApplied = true;
    this._userService
      .filterMinesitesFor(this.selectedCompanies)
      .then((value) => {
        this.filteredMinesites = [];
        for (const minesite of this.minesites) {
          const index = value.indexOf(minesite.Id);
          if (index >= 0) {
            this.filteredMinesites.push(minesite);
          }
        }
      });
  }

  public addSelectedMineSiteToAssignments(): void {
    //see note about selectedCompany in addSelectedCompanyToAssignments
    if (this.finalMinesites.some((m) => m.Id == this.selectedMinesites)) return;
    this.finalMinesites.push(
      this.minesites.find((m) => m.Id == this.selectedMinesites)
    );
    this.companyfilterApplied = true;
  }

  public removeFromMineSiteAssignments(): void {
    if (
      this.finalMinesites.some(
        (m) => m.Id === Number(this.selectedMinesitesForRemoval)
      )
    ) {
      this.finalMinesites = this.finalMinesites.filter(
        (m) => m.Id !== Number(this.selectedMinesitesForRemoval)
      );
      this.companyfilterApplied = true;
    }
  }

  public addSelectedCompanyToAssignments(): void {
    //Note: this.selectedCompany is the company Id, it is cast as a number, but does not compare to company.Id exactly, use ==
    if (this.finalCompanies.some((c) => c.Id == this.selectedCompany)) return;
    this.finalCompanies.push(
      this.companies.find((c) => c.Id == this.selectedCompany)
    );
    this.companyfilterApplied = true;
  }

  public removeFromCompanyAssignments(): void {
    if (
      this.finalCompanies.some(
        (c) => c.Id === Number(this.selectedCompanyForRemoval)
      )
    ) {
      this.finalCompanies = this.finalCompanies.filter(
        (c) => c.Id !== Number(this.selectedCompanyForRemoval)
      );
      this.companyfilterApplied = true;
    }
  }

  public clearCompanyFilter(): void {
    this.selectedCompanies = [];
    this.selectedMinesites = -1;
    this.filteredMinesites = this.minesites;
    this.companyfilterApplied = false;
  }

  public clearMinesiteFilter(): void {
    this.finalMinesites = [];
  }

  /**
   * Due to async nature of the service calls, we need to ensure that all data is loaded before proceeding. When ready, set values of select boxes
   * @returns
   */
  public handleCompanyAssignment(): void {
    if (this.loadingCompanies || this.loadingCompanyAssignments) return;
    this.finalCompanies = [];
    for (const surveyCompany of this.surveyCompanys) {
      let company = this.companies.find((c) => c.Id == surveyCompany.CompanyId);
      if (company) {
        this.finalCompanies.push(company);
      }
    }
    this.loadingCompanyAssignments = false;
  }

  /**
   * Due to async nature of the service calls, we need to ensure that all data is loaded before proceeding. When ready, set values of select boxes
   * @returns
   */
  public handleMinesiteAssignment(): void {
    if (
      this.loadingCompanies ||
      this.loadingMinesites ||
      this.loadingMinesiteAssignments
    )
      return;

    this.finalMinesites = [];
    for (const surveyMinesite of this.surveyMinesites) {
      let minesite = this.minesites.find(
        (m) => m.Id == surveyMinesite.MinesiteId
      );
      if (minesite) {
        this.finalMinesites.push(minesite);
      }
    }
    this.loadingMinesiteAssignments = false;
  }

  public loadSurveyAssignments(): void {
    if (this.surveySettings.SurveyAssignment == 2) {
      this.loadingCompanies = true;
      this.loadingCompanyAssignments = true;
      this._companyService.getCompanies();
      this._surveyService.getSurveyCompanies(this.surveySettings.Pkid);
    } else if (this.surveySettings.SurveyAssignment == 3) {
      this.loadingCompanies = true;
      this.loadingMinesites = true;
      this.loadingCompanyAssignments = true;
      this.loadingMinesiteAssignments = true;
      this._companyService.getCompanies();
      this._minesiteService.getMinesites();
      this._surveyService.getSurveyMinesites(this.surveySettings.Pkid);
    }
  }

  public sortBy(field: string): void {
    if (this.orderBy == field) {
      this.ascending = !this.ascending;
    } else {
      this.ascending = true;
      this.orderBy = field;
    }

    this.processing = true;
    this.surveySettingsList.init();
    this._surveyService.getAllSurveySettings(
      this.filterApplied,
      this.orderBy,
      this.ascending,
      this.filterTitle,
      this.filterLanguage,
      this.filterAllowIgnore,
      this.filterIsActive,
      this.filterCreatedBy,
      this.startDate,
      this.expiresDate
    );
  }

  // PDF Viewer Methods
  public onLoadPDF(pdf: PDFDocumentProxy) {
    // do anything with "pdf"
  }

  public onPDFLoadError(error: any) {
    console.error("error loading pdf", error);
  }

  public onPDFLoadProgress(progressData: PDFProgressData) {
    // do anything with progress data. For example progress indicator
  }

  public retrievedSurveyDocumentPDFId: number = 0;
  public getSurveyPDF() {
    if (
      this.surveySettings.Pkid == 0 ||
      this.surveySettings.Pkid === this.retrievedSurveyDocumentPDFId
    )
      return;

    this.downloadingDocument = true;
    this._surveyService.downloadSurveyPDF(this.surveySettings.Pkid).subscribe(
      (data: Blob) => {
        const fileReader = new FileReader();

        fileReader.onloadend = () => {
          this.pdfSrc = new Uint8Array(fileReader.result as ArrayBuffer);
          this.downloadingDocument = false;
        };
        fileReader.readAsArrayBuffer(data);
        this.retrievedSurveyDocumentPDFId = this.surveySettings.Pkid;
      },
      (error: any) => {
        console.error(error);
        this.errModalTitle = "Error Downloading Survey";
        this.errModalMsg = error;
        this.errModal.show();
        this.downloadingDocument = false;
      }
    );
  }
  // End PDF Viewer Methods

  public setCurrentView(view: SurveyManagementView): void {
    switch (view) {
      case SurveyManagementView.SurveyInformation:
        //no special logic
        break;
      case SurveyManagementView.UploadPDF:
        if (this.dataEntryMode === DataEntryMode.Edit) {
          //update view
        } else {
          this.errModalTitle = "PDF Upload Not Available";
          this.errModalMsg =
            "Please create and save the document before uploading the PDF.";
          this.errModal.show();
          return;
        }
        break;
      case SurveyManagementView.Assignments:
        if (
          this.surveySettings.SurveyAssignment == 2 ||
          this.surveySettings.SurveyAssignment == 3
        ) {
          this.loadSurveyAssignments();
        } else {
          this.errModalTitle = "Survey Assignment Not Available";
          this.errModalMsg =
            "Please select a target entity before advancing to selection.";
          this.errModal.show();
          return;
        }
        break;
      case SurveyManagementView.SurveyPreview:
        if (this.surveySettings.Pkid > 0) {
          this.getSurveyPDF();
        } else {
          this.errModalTitle = "Survey Preview Not Available";
          this.errModalMsg = "Please upload a survey document first.";
          this.errModal.show();
          return;
        }
        break;
      case SurveyManagementView.SurveyReport:
        if (this.dataEntryMode === DataEntryMode.Edit) {
          this._surveyService.getSurveyStatusesBySurveyId(
            this.surveySettings.Pkid
          );
        } else {
          this.errModalTitle = "Report Not Available";
          this.errModalMsg =
            "Please create and save the document before viewing report.";
          this.errModal.show();
          return;
        }
        break;
      default:
        view = SurveyManagementView.SurveyInformation;
        break;
    }

    this.currentView = view;
  }

  public isSort(field: string) {
    return field == this.orderBy;
  }

  public isSortDesc(field: string) {
    return this.isSort(field) && !this.ascending;
  }

  public edit(surveySettings: SurveySettings): void {
    this.surveySettings = surveySettings;
    this.surveySettingsUnaltered = JSON.parse(JSON.stringify(surveySettings));

    this.setCurrentView(SurveyManagementView.SurveyInformation);
    this.uploadAzurePDFCompleted = false;
    this.processingAzurePDF = false;
    this.downloadingDocument = false;
    this.uploadAzurePDFError = false;
    this.dataEntryMode = DataEntryMode.Edit;
    this.changesMade = false;

    (document.getElementById("pdfFileInput") as HTMLInputElement).value = null;

    // Load the document history
    this.historyDocuments = [];

    this._surveyService.getSurveyDocumentHistory(surveySettings.FileMetadataId);

    this.editSurveyModal.show();
  }

  public duplicate(dupSurveySettings: SurveySettings): void {
    this.setCurrentView(SurveyManagementView.SurveyInformation);
    this.uploadAzurePDFCompleted = false;
    this.processingAzurePDF = false;
    this.downloadingDocument = false;
    this.uploadAzurePDFError = false;
    this.dataEntryMode = DataEntryMode.Add;
    this.changesMade = false;

    (document.getElementById("pdfFileInput") as HTMLInputElement).value = null;

    //default to active is false, settings will likely need to be duplicated

    this.surveySettings = new SurveySettings();
    this.surveySettings.Pkid = 0;
    this.surveySettings.Title = dupSurveySettings.Title + " Copy";
    this.surveySettings.Description = dupSurveySettings.Description;
    this.surveySettings.Message = dupSurveySettings.Message;
    this.surveySettings.StartDate = dupSurveySettings.StartDate;
    this.surveySettings.ExpiresDate = dupSurveySettings.ExpiresDate;
    this.surveySettings.Language = dupSurveySettings.Language;
    this.surveySettings.AllowIgnore = dupSurveySettings.AllowIgnore;
    this.surveySettings.IsActive = false;
    this.surveySettings.FileMetadataId = dupSurveySettings.FileMetadataId;
    this.surveySettings.CreatedBy = dupSurveySettings.CreatedBy;
    this.surveySettings.CreatedOn = dupSurveySettings.CreatedOn;
    this.surveySettings.ModifiedBy = dupSurveySettings.ModifiedBy;
    this.surveySettings.ModifiedOn = dupSurveySettings.ModifiedOn;
    this.surveySettings.CreatedByUsername = dupSurveySettings.CreatedByUsername;
    this.surveySettings.ModifiedByUsername =
      dupSurveySettings.ModifiedByUsername;
    this.surveySettings.SurveyAssignment = dupSurveySettings.SurveyAssignment;

    switch (dupSurveySettings.SurveyAssignment) {
      case 1:
        //All Users
        break;
      case 2:
        //Companies
        //this._companyService.getCompanies();
        //this._surveyService.getSurveyCompanies(dupSurveySettings.Pkid);
        break;
      case 3:
        //Minesites
        //this._companyService.getCompanies();
        //this._minesiteService.getMinesites();
        //this._surveyService.getSurveyMinesites(dupSurveySettings.Pkid);
        break;
      default:
        break;
    }

    this.historyDocuments = [];
    this.editSurveyModal.show();
  }

  public deleteSurvey(surveySettings: SurveySettings): void {
    this.surveySettings = surveySettings;
    this.deleteConfirmationProductName = surveySettings.Title.toString();
    this.deleteSurveyId = surveySettings.Pkid;
    this.delConfirmModal.show();
  }

  public cancelDeleteConfirmation(): void {
    this.deleteConfirmationProductName = "";
    this.deleteSurveyId = 0;
    this.delConfirmModal.hide();
  }

  public disableSurvey(surveySettings: SurveySettings): void {
    this.surveySettings = surveySettings;
    this.deleteConfirmationProductName = surveySettings.Title.toString();
    this.deleteSurveyId = surveySettings.Pkid;
    this.disableConfirmModal.show();
  }

  public cancelDisableConfirmation(): void {
    this.deleteConfirmationProductName = "";
    this.deleteSurveyId = 0;
    this.disableConfirmModal.hide();
  }

  public resolveConflicts(): void {
    let isCreate = false;
    if (this.dataEntryMode === DataEntryMode.Add) {
      isCreate = true;
    }

    this._surveyService.resolveSurveyConflicts(
      isCreate,
      this.surveyConflictResolutions[0].CurrentSurvey,
      this.currentUserId
    );

    this.reloadSurveys();
    this.editSurveyModal.hide();
    this.invalidDate.hide();
  }

  public cancelInvalidDate(): void {
    this.surveyConflictResolutions = [];
    this.invalidDate.hide();
  }

  public cancelSurveyConflictModal(): void {
    this.surveyConflictResolutions = [];
    this.surveyConflictModal.hide();
  }

  public deleteDocument(): void {
    this._surveyService.deleteSurveySettings(
      this.deleteSurveyId,
      this.currentUserId
    );
  }

  public disableDocument(): void {
    this._surveyService.disableSurveySettings(
      this.deleteSurveyId,
      this.currentUserId
    );
  }

  public enableSurvey(surveySettings: SurveySettings): void {
    this._surveyService.enableSurveySettings(
      surveySettings.Pkid,
      this.currentUserId
    );
  }

  public complete(): void {
    this.changesMade = true;

    if (this.surveySettings.Pkid === 0) {
      this._surveyService.createSurveySettings(
        this.surveySettings,
        this.currentUserId
      );
    } else {
      this._surveyService.updateSurveySettings(
        this.surveySettings,
        this.currentUserId
      );
      //TODO: if updating type of assignments, need to confirm that assignments will be cleared and then clear them
    }

    if (this.surveySettings.SurveyAssignment == 2) {
      let finalCompanyIds = [];
      this.finalCompanies.forEach((company) => {
        finalCompanyIds.push(company.Id);
      });
      this._surveyService.linkOrUnlinkCompaniesToSurvey(
        this.surveySettings.Pkid,
        finalCompanyIds
      );
    } else if (this.surveySettings.SurveyAssignment == 3) {
      let finalMinesiteIds = [];
      this.finalMinesites.forEach((minesite) => {
        finalMinesiteIds.push(minesite.Id);
      });
      this._surveyService.linkOrUnlinkMinesitesToSurvey(
        this.surveySettings.Pkid,
        finalMinesiteIds
      );
    }
  }

  public cancel(): void {
    this.editSurveyModal.hide();

    // reset screen flags
    this.processingAzurePDF = false;
    this.uploadAzurePDFCompleted = false;
    this.downloadingDocument = false;
    this.uploadAzurePDFError = false;

    // refresh the list
    if (this.changesMade) {
      //changesMade only refers to saved changes
      this.reloadSurveys();
    } else if (
      JSON.stringify(this.surveySettings) !==
      JSON.stringify(this.surveySettingsUnaltered)
    ) {
      // revert changes to survey (refresh list), but need to detect changes
      this.reloadSurveys();
    }
  }

  private reloadSurveys() {
    this.processing = true;
    this.totalDocuments = 0;
    this.surveySettingsList.init();
    this.changesMade = false;
    this._surveyService.getAllSurveySettings(
      this.filterApplied,
      this.orderBy,
      this.ascending,
      this.filterTitle,
      this.filterLanguage,
      this.filterAllowIgnore,
      this.filterIsActive,
      this.filterCreatedBy,
      this.startDate,
      this.expiresDate
    );
  }

  public closeErrModal(): void {
    this.errModal.hide();
  }

  public UploadFile(): void {
    const filePathInput: any = $("#pdfFileInput");

    const fileNameValidation = this.surveySettings.Title;
    let len = 14;
    if (filePathInput[0].files.length > 0) {
      const file: any = filePathInput[0].files[0];
      const fileName: string = file.name;
      len = fileName.indexOf(".");
      // The file name must match the Publication Number
      // Add the document record
      // 20200106 mrose Translated Manual Tilte (ProManualTitle) always take precedence over English Manual Title (ProductDescription)
      const updatedFileName = fileNameValidation + ".PDF";
      this.updatedFileName = updatedFileName;

      if (typeof this.surveySettings.Title === "undefined") {
        this._surveyService.createSurveyDocument(
          updatedFileName,
          this.surveySettings.Pkid,
          this.surveySettings.FileMetadataId,
          this.currentUserId
        );
      } else {
        this._surveyService.createSurveyDocument(
          updatedFileName.substring(0, updatedFileName.indexOf(".PDF")) +
            ".PDF",
          this.surveySettings.Pkid,
          this.surveySettings.FileMetadataId,
          this.currentUserId
        );
      }

      this.changesMade = true;
    } else {
      this.errModalTitle = "PDF Upload Error";
      this.errModalMsg = "PDF file must be selected.";
      this.errModal.show();
    }
  }

  public pdfFileChange() {
    this.uploadAzurePDFCompleted = false;
    this.uploadAzurePDFError = false;
  }

  public addNewSurvey(): void {
    this.setCurrentView(SurveyManagementView.SurveyInformation);
    this.uploadAzurePDFCompleted = false;
    this.processingAzurePDF = false;
    this.uploadAzurePDFError = false;
    this.dataEntryMode = DataEntryMode.Add;
    this.changesMade = false;

    (document.getElementById("pdfFileInput") as HTMLInputElement).value = null;

    this.surveySettings = new SurveySettings();
    this.surveySettings.Pkid = 0;
    this.surveySettings.Title = "";
    this.surveySettings.Description = "";
    this.surveySettings.Message = "";
    this.surveySettings.Language = "ENG";
    this.surveySettings.AllowIgnore = false;
    this.surveySettings.IsActive = false;
    this.surveySettings.SurveyAssignment = 1;
    this.historyDocuments = [];

    this.editSurveyModal.show();
  }

  public openFilter(): void {
    this.filterSurveysModal.show();
  }

  public closeFilter(): void {
    this.filterSurveysModal.hide();
  }

  public applyFilter(): void {
    this.filterApplied = true;

    this.processing = true;
    this._surveyService.applyFilterToSurveySettings(
      this.filterApplied,
      this.orderBy,
      this.ascending,
      this.filterTitle,
      this.filterLanguage,
      this.filterAllowIgnore,
      this.filterIsActive,
      this.filterCreatedBy,
      this.startDate,
      this.expiresDate
    );
    this.filterSurveysModal.hide();
  }

  public clearFilter(): void {
    this.filterTitle = "";
    this.filterLanguage = "";
    this.filterCreatedBy = "";
    this.filterAllowIgnore = false;
    this.filterIsActive = false;
    this.filterApplied = false;
    this.processing = true;
    this._surveyService.applyFilterToSurveySettings(
      this.filterApplied,
      this.orderBy,
      this.ascending,
      this.filterTitle,
      this.filterLanguage,
      this.filterAllowIgnore,
      this.filterIsActive,
      this.filterCreatedBy,
      this.startDate,
      this.expiresDate
    );
    this.filterSurveysModal.hide();
  }

  public EnrichView(value: SurveySettings) {
    this.surveySettings.Pkid = value.Pkid;
    this.surveySettings.Title = value.Title;
    this.surveySettings.Description = value.Description;
    this.surveySettings.Message = value.Message;
    this.surveySettings.StartDate = value.StartDate;
    this.surveySettings.ExpiresDate = value.ExpiresDate;
    this.surveySettings.Language = value.Language;
    this.surveySettings.AllowIgnore = value.AllowIgnore;
    this.surveySettings.IsActive = value.IsActive;
    this.surveySettings.FileMetadataId = value.FileMetadataId;
    this.surveySettings.CreatedBy = value.CreatedBy;
    this.surveySettings.CreatedOn = value.CreatedOn;
    this.surveySettings.CreatedOnString = value.CreatedOnString;
    this.surveySettings.ModifiedBy = value.ModifiedBy;
    this.surveySettings.ModifiedOn = value.ModifiedOn;
    this.surveySettings.ModifiedOnString = value.ModifiedOnString;
    this.surveySettings.CreatedByUsername = value.CreatedByUsername;
    this.surveySettings.ModifiedByUsername = value.ModifiedByUsername;
    this.surveySettings.SurveyAssignment = value.SurveyAssignment;

    //Reset templates
  }
}
